module.exports = __webpack_public_path__ + "img/album23_16.ffb393aa.jpg";